import {useSelector} from 'react-redux';

import {selectClinicData} from '@/src/app/store/clinic/clinicDataSlice';
import useUserActions from '@/src/app/store/user/useUserActions';
import ClinicAddressWidget from '@/src/profile/accountSettings/containers/ClinicAddressWidget';
import ClinicCertificateBranding from '@/src/profile/accountSettings/containers/ClinicCertificateBranding';
import ClinicInfoSettings from '@/src/profile/accountSettings/containers/ClinicInfoSettings';
import ClinicVerificationDocument from '@/src/profile/accountSettings/containers/ClinicVerificationDocument';

import MyProfileWrapper from '../../common/containers/MyProfileWrapper';
import AccountSettingsWidget from '../containers/AccountSettingsWidget';
import css from '../styles/ClinicAccountSettingsLayout.module.css';

const ClinicAccountSettingsLayout = () => {
  const {user} = useUserActions();
  const clinicData = useSelector(selectClinicData);

  return (
    <MyProfileWrapper>
      {clinicData.isFetched && (
        <div className={css.settingsWrapper}>
          <div className={css.settingsSection}>
            <ClinicInfoSettings />
          </div>
          <div className={css.settingsSection}>
            <ClinicVerificationDocument />
          </div>
          <div className={css.settingsSection}>
            <ClinicAddressWidget />
          </div>
          <div className={css.settingsSection}>
            <ClinicCertificateBranding />
          </div>
          <AccountSettingsWidget
            isEmailSubscriptionActive={user?.profile?.is_marketing_subscribe}
            userType={user.user.type}
          />
        </div>
      )}
    </MyProfileWrapper>
  );
};

export default ClinicAccountSettingsLayout;
